import React, { useEffect, useRef } from "react";
import styles from "./Home.module.scss";
import MenuSection from "./MenuSection";
import SellerSection from "./SellerSection";
// import AboutPlatformSection from "./AboutPlatformSection";
import AdvantageSection from "./AdvantageSection";
import ReliablySection from "./ReliablySection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";
import { Container } from "react-bootstrap";
import AboutUsSection from "./AboutUsSection";

const Home: React.FC = () => {
  useEffect(() => {
    document.title = `Roomseller`;
  }, []);
  return (
    <Container fluid className={styles.Home}>
      <MenuSection />

      <Container className={styles.contentWrapper}>
        <AboutUsSection />
        <SellerSection />
        <ReliablySection />
        <AdvantageSection />
        <ContactSection />
      </Container>
      <Footer />
    </Container>
  );
};

export default Home;
